module.exports = __webpack_public_path__ + "assets/8f49cc54a6dc797972dfbc67d573dafe.png";